import { createAction } from 'redux-actions';

export const switchCreateReservationPanel = createAction(
  'SWITCH_CREATE_RESERVATION_PANEL'
);
